import React, { useState } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import './estilo.css';

const logoClaro = process.env.PUBLIC_URL + '/img/logo_horizontal_semFundo.png';
const icone = process.env.PUBLIC_URL + '/img/iconeIgrejaPro_sem%20fundo.png';

// Painel de gestão — quem já é cliente entra por aqui.
const urlSistema = 'https://gestao.igrejapro.app.br';

function Home() {
  const [menuAberto, setMenuAberto] = useState(false);

  function enviarContato(e) {
    e.preventDefault();
    toastr.info('Formulário em construção — em breve você poderá enviar direto por aqui.');
  }

  return (
    <div className="ip-page">
      <header className="ip-header">
        <div className="ip-shell ip-header__row">
          <a href="#topo" className="ip-header__brand">
            <img src={logoClaro} alt="IgrejaPro" />
          </a>

          <nav className="ip-nav">
            <a href="#recursos">Recursos</a>
            <a href="#app">Aplicativo</a>
            <a href="#como-funciona">Como funciona</a>
            <a href="#planos">Planos</a>
          </nav>

          <div className="ip-header__actions">
            <a href={urlSistema} className="ip-header__login">
              <i className="bi bi-box-arrow-in-right" />
              Acessar Sistema
            </a>
            <a href="#contato" className="ip-header__cta">Fale com a gente</a>
          </div>

          <button
            className="ip-nav-toggle"
            aria-label={menuAberto ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={menuAberto}
            onClick={() => setMenuAberto((v) => !v)}
          >
            <i className={menuAberto ? 'bi bi-x-lg' : 'bi bi-list'} />
          </button>
        </div>

        {menuAberto && (
          <div className="ip-shell ip-mobile-menu">
            <a href="#recursos" onClick={() => setMenuAberto(false)}>Recursos</a>
            <a href="#app" onClick={() => setMenuAberto(false)}>Aplicativo</a>
            <a href="#como-funciona" onClick={() => setMenuAberto(false)}>Como funciona</a>
            <a href="#planos" onClick={() => setMenuAberto(false)}>Planos</a>
            <a href={urlSistema} className="ip-header__login" onClick={() => setMenuAberto(false)}>
              <i className="bi bi-box-arrow-in-right" />
              Acessar Sistema
            </a>
            <a href="#contato" className="ip-header__cta" onClick={() => setMenuAberto(false)}>Fale com a gente</a>
          </div>
        )}
      </header>

      {/* ---------------------------- Hero ---------------------------- */}
      <section id="topo" className="ip-hero">
        <div className="ip-shell ip-hero__grid">
          <div>
            <img src={icone} alt="" className="ip-hero__eyebrow-icon" />
            <h1>Sua igreja já tem uma estrutura. Seu sistema devia ter a mesma.</h1>
            <p className="ip-hero__lede">
              Da região à célula, do dízimo à etiqueta do patrimônio — o IgrejaPro organiza cada
              camada da sua igreja num só lugar, no computador da secretaria e no celular de quem
              serve.
            </p>
            <div className="ip-hero__actions">
              <a href="#contato" className="ip-btn">Comece agora</a>
              <a href="#recursos" className="ip-link">Ver o que o sistema faz</a>
            </div>
          </div>

          <div className="ip-tree" aria-hidden="true">
            <p className="ip-tree__label">A estrutura da sua igreja, do jeito que ela já é</p>
            <div className="ip-tree__node ip-tree__node--depth-1">
              <span className="ip-tree__dot" />
              <span className="ip-tree__name">Região Norte</span>
              <span className="ip-tree__meta">3 supervisões</span>
            </div>
            <div className="ip-tree__node ip-tree__node--depth-2">
              <span className="ip-tree__dot" />
              <span className="ip-tree__name">Supervisão Central</span>
              <span className="ip-tree__meta">8 células</span>
            </div>
            <div className="ip-tree__node ip-tree__node--depth-3">
              <span className="ip-tree__dot" />
              <span className="ip-tree__name">Célula Betel</span>
              <span className="ip-tree__meta">Quarta, 20h</span>
            </div>
            <div className="ip-tree__node ip-tree__node--depth-4">
              <span className="ip-tree__dot" />
              <span className="ip-tree__name">Chamada por QR</span>
              <span className="ip-tree__meta">cada membro confirma a própria presença</span>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------------- Recursos (capítulos) ---------------------------- */}
      <section id="recursos" className="ip-chapters">
        <div className="ip-shell">
          <div className="ip-chapters__intro">
            <h2>Cada frente da igreja, no lugar certo</h2>
            <p>
              Nada de um sistema genérico com um módulo "igreja" colado por cima. Cada tela do
              IgrejaPro foi pensada a partir de como uma igreja realmente funciona — da célula que
              se multiplica ao dízimo que precisa ser conferido no fim do mês.
            </p>
          </div>

          <div className="ip-chapter">
            <div className="ip-chapter__body">
              <span className="ip-chapter__index">Membros</span>
              <h3>Cada pessoa, do primeiro culto ao batismo</h3>
              <p>
                Cadastro completo, arrolamentos, vínculo familiar e uma linha do tempo com cada
                marco — batismo, mudança de célula, promoção de cargo. Quem está de aniversário
                nos próximos dias aparece sozinho, sem planilha.
              </p>
              <p className="ip-chapter__detail">
                Relatórios prontos por região, supervisão, célula ou faixa etária.
              </p>
            </div>
            <div className="ip-chapter__figure">
              <div className="ip-figure-cells">
                <div className="ip-figure-row">
                  <span className="ip-figure-pill">Batismo</span>
                  <span className="ip-figure-pill">Casado(a)</span>
                </div>
                <div className="ip-figure-row">
                  <span className="ip-figure-pill">Célula Betel</span>
                </div>
                <div className="ip-figure-row">
                  <span className="ip-figure-pill ip-figure-pill--gold">Aniversário em 3 dias</span>
                </div>
              </div>
            </div>
          </div>

          <div className="ip-chapter ip-chapter--reverse">
            <div className="ip-chapter__body">
              <span className="ip-chapter__index">Células</span>
              <h3>Da região até a roda de convidados na sala</h3>
              <p>
                A hierarquia Região → Supervisão → Célula existe de verdade no sistema, não só no
                organograma da parede. O líder abre a chamada e mostra um QR único daquele
                encontro — cada pessoa aponta o celular e confirma a própria presença.
              </p>
              <p className="ip-chapter__detail">
                Três presenças promovem um visitante a membro; três faltas seguidas sem
                justificativa avisam o líder. Automático, sem precisar lembrar.
              </p>
            </div>
            <div className="ip-chapter__figure">
              <div className="ip-figure-qr">
                {[1,0,1,1,0,0,1,0,1,1,1,1,0,1,0,0,0,1,1,0,1,0,1,0,1].map((on, i) => (
                  <span key={i} className={on ? '' : 'off'} />
                ))}
              </div>
            </div>
          </div>

          <div className="ip-chapter">
            <div className="ip-chapter__body">
              <span className="ip-chapter__index">Financeiro</span>
              <h3>Dízimo lançado, contribuinte identificado</h3>
              <p>
                Importe o extrato OFX do banco e o sistema já reconhece quem fez cada depósito
                pelo CPF ou pelo nome na descrição — sem digitar lançamento por lançamento.
                Categorias, campanhas e contas correntes organizadas, com relatório sempre pronto
                para a prestação de contas.
              </p>
            </div>
            <div className="ip-chapter__figure">
              <div className="ip-figure-ledger">
                <div className="ip-figure-ledger__row">
                  <span>PIX recebido — 123.***.***-45</span>
                  <span className="ip-figure-ledger__match">Ana Souza</span>
                </div>
                <div className="ip-figure-ledger__row">
                  <span>TED — JOAO P SILVA</span>
                  <span className="ip-figure-ledger__match">João Silva</span>
                </div>
                <div className="ip-figure-ledger__row">
                  <span className="ip-figure-ledger__who">Depósito não identificado</span>
                  <span>—</span>
                </div>
              </div>
            </div>
          </div>

          <div className="ip-chapter ip-chapter--reverse">
            <div className="ip-chapter__body">
              <span className="ip-chapter__index">Patrimônio</span>
              <h3>Uma etiqueta para cada cadeira, cada bem</h3>
              <p>
                Cadastre "cadeira", diga quantas são 100, e o sistema gera 100 registros
                individuais — cada um com seu código e sua etiqueta com QR, pronta para imprimir.
                Escaneou, sabe o setor: se a cadeira saiu da nave e foi parar no Kids, o cadastro
                acompanha.
              </p>
            </div>
            <div className="ip-chapter__figure">
              <div className="ip-figure-tag">
                <div className="ip-figure-tag__code" />
                <div className="ip-figure-tag__text">
                  <strong>PAT-000247</strong>
                  Cadeira · Setor: Kids
                </div>
              </div>
            </div>
          </div>

          <div className="ip-more">
            <div className="ip-more__item">
              <h4>Check-in infantil</h4>
              <p>Ticket com QR na hora do check-in; retirada só por quem fez a entrada ou pela equipe.</p>
            </div>
            <div className="ip-more__item">
              <h4>Escalas</h4>
              <p>Voluntário recebe, confirma ou recusa a escala direto pelo aplicativo.</p>
            </div>
            <div className="ip-more__item">
              <h4>Comunicação</h4>
              <p>Aviso segmentado por região, célula ou ministério — sem mandar pra igreja inteira à toa.</p>
            </div>
            <div className="ip-more__item">
              <h4>Eventos</h4>
              <p>Inscrição, controle de vagas e presença de cada evento num só lugar.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------------- App mobile ---------------------------- */}
      <section id="app" className="ip-app">
        <div className="ip-shell ip-app__grid">
          <div>
            <h2>O mesmo sistema, no bolso de quem serve</h2>
            <p className="ip-app__lede">
              Membro, líder ou pastor — cada um vê só o que precisa, direto do celular, sem
              precisar abrir o computador da secretaria.
            </p>
            <div className="ip-app__list">
              <div className="ip-app__list-item">
                <span className="ip-app__list-dot" />
                <div>
                  <strong>Início, Eventos, Checkin, Perfil</strong>
                  <span>Quatro abas fixas pro que se usa todo dia — o resto mora no menu.</span>
                </div>
              </div>
              <div className="ip-app__list-item">
                <span className="ip-app__list-dot" />
                <div>
                  <strong>Um checkin, três respostas</strong>
                  <span>Toca em Checkin e escolhe: célula, evento ou Kids — a tela certa abre na hora.</span>
                </div>
              </div>
              <div className="ip-app__list-item">
                <span className="ip-app__list-dot" />
                <div>
                  <strong>Aniversariantes e recados na tela inicial</strong>
                  <span>Quem faz aniversário essa semana e os avisos da igreja, sem precisar procurar.</span>
                </div>
              </div>
              <div className="ip-app__list-item">
                <span className="ip-app__list-dot" />
                <div>
                  <strong>Modo claro e escuro</strong>
                  <span>O app se adapta ao horário do culto — de manhã ou de noite.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="ip-phone" aria-hidden="true">
            <div className="ip-phone__screen">
              <p className="ip-phone__greeting">Boa noite, Ana</p>
              <p className="ip-phone__sub">Minha área</p>
              <div className="ip-phone__cards">
                <div className="ip-phone__card"><strong>Células</strong>Confirmar presença</div>
                <div className="ip-phone__card"><strong>Área Kids</strong>Check-in dos filhos</div>
                <div className="ip-phone__card"><strong>Escalas</strong>2 pendentes</div>
                <div className="ip-phone__card"><strong>Dízimos</strong>Minhas contribuições</div>
              </div>
              <div className="ip-phone__tabbar">
                <div className="ip-phone__tab ip-phone__tab--active">
                  <span className="ip-phone__tab-dot" />
                  Início
                </div>
                <div className="ip-phone__tab">
                  <span className="ip-phone__tab-dot" />
                  Eventos
                </div>
                <div className="ip-phone__tab">
                  <span className="ip-phone__tab-dot" />
                  Checkin
                </div>
                <div className="ip-phone__tab">
                  <span className="ip-phone__tab-dot" />
                  Perfil
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------------- Como funciona ---------------------------- */}
      <section id="como-funciona" className="ip-steps">
        <div className="ip-shell">
          <div className="ip-steps__head">
            <h2>Do zero ao primeiro culto gerenciado</h2>
            <p>Não é preciso migrar tudo de uma vez — dá pra começar pequeno e ir trazendo o resto.</p>
          </div>
          <div className="ip-steps__list">
            <div className="ip-step">
              <span className="ip-step__num">01</span>
              <h3>Cadastre sua igreja e sua equipe</h3>
              <p>Você e quem mais precisar de acesso — cada um com seu nível de permissão.</p>
            </div>
            <div className="ip-step">
              <span className="ip-step__num">02</span>
              <h3>Monte a estrutura</h3>
              <p>Regiões, supervisões, células e ministérios — do jeito que já existe na sua igreja.</p>
            </div>
            <div className="ip-step">
              <span className="ip-step__num">03</span>
              <h3>Comece a usar</h3>
              <p>Membros e voluntários entram pelo próprio celular a partir do primeiro dia.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------------- Planos ---------------------------- */}
      <section id="planos" className="ip-plans">
        <div className="ip-shell">
          <div className="ip-plans__head">
            <h2>Um plano do tamanho da sua igreja</h2>
            <p>Comece pelo essencial e mude de plano quando a igreja crescer.</p>
          </div>
          <div className="ip-plans__grid">
            <div className="ip-plan">
              <span className="ip-plan__name">Essencial</span>
              <p className="ip-plan__desc">Ideal para igrejas pequenas dando os primeiros passos na gestão digital.</p>
              <p className="ip-plan__limit">Até 150 membros</p>
              <div className="ip-plan__price">R$ 99,90 <span>/mês</span></div>
              <a href="#contato" className="ip-plan__cta">Falar com a gente</a>
            </div>
            <div className="ip-plan ip-plan--featured">
              <span className="ip-plan__name">Crescendo</span>
              <p className="ip-plan__desc">Para igrejas em crescimento, com mais células e mais gente servindo.</p>
              <p className="ip-plan__limit">Até 500 membros</p>
              <div className="ip-plan__price">R$ 159,90 <span>/mês</span></div>
              <a href="#contato" className="ip-plan__cta">Falar com a gente</a>
            </div>
            <div className="ip-plan">
              <span className="ip-plan__name">Completo</span>
              <p className="ip-plan__desc">Recursos avançados e suporte dedicado para igrejas de grande porte.</p>
              <p className="ip-plan__limit">Membros ilimitados</p>
              <div className="ip-plan__price">R$ 219,90 <span>/mês</span></div>
              <a href="#contato" className="ip-plan__cta">Falar com a gente</a>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------------------- Contato ---------------------------- */}
      <section id="contato" className="ip-contact">
        <div className="ip-shell ip-contact__grid">
          <div>
            <h2>Fale com a gente</h2>
            <p className="ip-contact__lede">
              Conta um pouco da sua igreja e o que você precisa organizar primeiro — a gente
              responde com os próximos passos.
            </p>
          </div>
          <form className="ip-form" onSubmit={enviarContato}>
            <div className="ip-form__row">
              <div>
                <label htmlFor="nome">Seu nome</label>
                <input id="nome" type="text" placeholder="Como podemos te chamar" required />
              </div>
              <div>
                <label htmlFor="igreja">Nome da igreja</label>
                <input id="igreja" type="text" placeholder="Igreja..." />
              </div>
            </div>
            <div>
              <label htmlFor="email">Seu e-mail</label>
              <input id="email" type="email" placeholder="voce@igreja.com" required />
            </div>
            <div>
              <label htmlFor="mensagem">Mensagem</label>
              <textarea id="mensagem" placeholder="Conte um pouco do que você precisa" />
            </div>
            <button type="submit" className="ip-btn">Enviar mensagem</button>
          </form>
        </div>
      </section>

      <footer className="ip-footer">
        <div className="ip-shell ip-footer__row">
          <img src={logoClaro} alt="IgrejaPro" />
          <p>&copy; {new Date().getFullYear()} IgrejaPro — desenvolvido por Software Plus.</p>
        </div>
      </footer>
    </div>
  );
}

export default Home;
